// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form, Checkbox } from 'informed';

import {
  ACTIVATE_PRINT_PATIENT,
  DEACTIVATE_PRINT_PATIENT,
} from '../../../actions/patientActions';

import InformationHistoryPage from '../informationHistory/InformationHistoryPage.jsx';
import CurrentProblemsPage from '../problem/CurrentProblemsPage.jsx';
import ResolvedProblemsPage from '../problem/ResolvedProblemsPage.jsx';
import ImmunizationsPage from '../immunization/ImmunizationsPage.jsx';
import WellChildChecksPage from '../wellChildCheck/WellChildChecksPage.jsx';
import TestingPage from '../testing/TestingPage.jsx';
import InfantPage from '../growthChart/infant/InfantPage.jsx';
import ChildPage from '../growthChart/child/ChildPage.jsx';
import VitalSignsPage from '../vitals/VitalSignsPage.jsx';
import ExternalReportsPage from '../externalReports/ExternalReportsPage.jsx';

import { PrimaryText } from '../../Typography.jsx';
import PageHeader from '../../PageHeader.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';
import ContentBox from '../../ContentBox.jsx';

import styles from '../../../styles/patientPages/print/printPatientPage.scss';

type Props = {
  match: Object,
  activatePrintPatient: Function,
  deactivatePrintPatient: Function,
}

type State = {
  checked: Object,
}

const PAGE_LIST = [
  'Info + History',
  'Current Dx/Tx',
  'Resolved Dx/Tx',
  'Immunizations',
  'Well Child Checks Summary',
  'Testing',
  'Growth Charts (Birth-36 months)',
  'Growth Charts (2-20 years)',
  'Vital Signs',
  'Misc Notes Summary',
  'External Reports',
];

class PrintPatientPageComponent extends Component<Props, State> {
  formApi: Object;

  constructor(props: Props) {
    super(props);
    const checked = {};
    for (let i = 0; i < PAGE_LIST.length; i++) {
      checked[PAGE_LIST[i]] = true;
    }
    this.state = {
      checked,
    };
  }

  componentDidMount() {
    this.props.activatePrintPatient();
  }

  componentWillUnmount() {
    this.props.deactivatePrintPatient();
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  checkAll = () => {
    const checked = {};
    for (let i = 0; i < PAGE_LIST.length; i++) {
      checked[PAGE_LIST[i]] = true;
    }
    this.formApi.setValues(checked);
  }

  uncheckAll = () => {
    const checked = {};
    for (let i = 0; i < PAGE_LIST.length; i++) {
      checked[PAGE_LIST[i]] = false;
    }
    this.formApi.setValues(checked);
  }

  updatePage = () => {
    this.setState({
      checked: this.formApi.getState().values,
    });
  }

  print = () => {
    window.print();
  }

  render() {
    const { match } = this.props;
    const { checked } = this.state;
    const checkboxes = PAGE_LIST.map(item => (
      <div key={item}>
        <Checkbox field={item} initialValue={true} />
        {item}
      </div>
    ));
    return (
      <div className={styles.pageContainer}>
        <div className={styles.hidden}>
          <PageHeader title='Patient Printout' />
          <ContentBox>
            <Link to={match.url.replace('/print', '')}><Button>Back to Patient</Button></Link>
          </ContentBox>
          <ContentBox>
            <PrimaryText>Page Selection</PrimaryText><br /><br />
            Printing for specific well child checks and problem progress notes not implemented yet.
            <br /><br />
            <Button onClick={this.checkAll}>Check All</Button>
            <Button onClick={this.uncheckAll}>Uncheck All</Button>
            <Form getApi={this.setFormApi} onChange={this.updatePage}>
              {checkboxes}
              <br />
              <PrimaryButton onClick={this.print}>Print</PrimaryButton>
            </Form>
          </ContentBox>
        </div>
        {checked['Info + History'] && <div className={styles.pageBreak}><InformationHistoryPage /></div>}
        {checked['Current Dx/Tx'] && <div className={styles.pageBreak}><CurrentProblemsPage /></div>}
        {checked['Resolved Dx/Tx'] && <div className={styles.pageBreak}><ResolvedProblemsPage /></div>}
        {checked.Immunizations && <div className={styles.pageBreak}><ImmunizationsPage /></div>}
        {checked['Well Child Checks Summary'] && <div className={styles.pageBreak}><WellChildChecksPage match={match} /></div>}
        {checked.Testing && <div className={styles.pageBreak}><TestingPage /></div>}
        {checked['Growth Charts (Birth-36 months)'] && <div className={styles.pageBreak}><InfantPage /></div>}
        {checked['Growth Charts (2-20 years)'] && <div className={styles.pageBreak}><ChildPage /></div>}
        {checked['Vital Signs'] && <div className={styles.pageBreak}><VitalSignsPage /></div>}
        {checked['External Reports'] && <div className={styles.pageBreak}><ExternalReportsPage /></div>}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  activatePrintPatient: () => dispatch({ type: ACTIVATE_PRINT_PATIENT }),
  deactivatePrintPatient: () => dispatch({ type: DEACTIVATE_PRINT_PATIENT }),
});

const PrintPatientPage = connect(
  null,
  mapDispatchToProps,
)(PrintPatientPageComponent);

export default PrintPatientPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/print/PrintPatientPage.jsx